import { App } from 'projects/internal/r1-component-library/src/lib/models/appcloud/app.model';
import { AppLicense } from 'projects/internal/r1-component-library/src/lib/models/appcloud/app-license.model';

/**
 * A subscription is an `Applicense` enriched with the billing details shown on the
 * UXPin "Apps" / "App Page" screens.
 *
 * TODO(backend): `autoRenew`, `billingAmount`, `billingPeriod`, `billingNote`, `quantity`,
 * `renewalDate` are not on `Applicense` yet.
 */
export type Subscription = AppLicense & {
    app?: App;
    autoRenew?: boolean;
    renewalDate?: string;
    billingAmount?: number;
    billingPeriod?: 'month' | 'year';
    billingNote?: string;
    quantity?: number;
};

export type SubscriptionPatch = Partial<
    Pick<Subscription, 'autoRenew' | 'quantity' | 'term' | 'usageEndDate' | 'renewalDate' | 'status'>
>;

export const SUBSCRIPTION_STATUS = {
    active: 'ACTIVE',
    expired: 'EXPIRED',
} as const;

export function isSubscriptionExpired(subscription: Subscription, now = new Date()): boolean {
    if (subscription.status && subscription.status.toUpperCase() === SUBSCRIPTION_STATUS.expired) {
        return true;
    }
    return !!subscription.usageEndDate && new Date(subscription.usageEndDate).getTime() < now.getTime();
}
